import {FORM_FIELD_HEIGHT} from "../../../TransactionsMonitoring/components/Filters/components/common_styles";

const styles = theme => ({
  pbButton: {
    background: '#28B9D7',
    height: FORM_FIELD_HEIGHT,

    [theme.breakpoints.up('sm')]: {
      minWidth: 285,
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%'
    }
  }
});

export default styles;